<template>
  <div class="container-fluid background-experiences">
    <IntroTitle
      :title="$t('home.cards.card-0.title')"
      padding="1dvw 30px 0px"
      paddingDesktop="3dvw 50px 0px"
      titleFontSize="1.6rem"
      titleMobileFontSize="1.3rem"
      descriptionAlign="initial"
      descriptionMobileAlign="center"
      transform="uppercase"
      effect="top-to-bottom--effect"
      :subtitle="$t('home.cards.card-0.subtitle')"
      :subtitleMobile="false"
    >
    </IntroTitle>
    <div class="cards-experiences">
      <template v-if="isLoading">
        <CardSkeleton
          imageHeight="190px"
          borderBottomLeft="0px"
          borderBottomRight="0px"
          v-for="index in 5"
          :key="index"
        />
      </template>
      <template v-else>
        <Card
          v-for="(experienceType, index) in experienceTypes"
          :key="index"
          :height="'auto'"
          :imageHeight="'auto'"
          :imageDesktopHeight="'auto'"
          :title="translate(experienceType.title)"
          :subtitle="translate(experienceType.description)"
          :image="imageHost + experienceType.reducedImageKey"
          @click="goTo(experienceType)"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
  import Card from '@/components/movistar/cards/Card.vue'
  import CardSkeleton from '@/components/movistar/skeletons/CardSkeleton.vue'
  import IntroTitle from '@/components/movistar/common/IntroTitle.vue'
  import { computed, onMounted, ref } from 'vue'
  import { useStore } from 'vuex'
  import router from '@/router'
  import commonMethods from '@/commonMethods'

  const { registerError, translate, scrollToClassName } = commonMethods()
  const store = useStore()

  const isLoading = ref(true)
  const imageHost = ref(process.env.VUE_APP_IMAGE_HOST)

  const someActiveExperience = (experiences) => {
    const now = new Date()
    return experiences.some(
      (experience) => experience.endDate == null || now <= new Date(experience.endDate)
    )
  }

  const experienceTypes = computed(() => {
    return store.getters['getExperienceTypes'].filter(
      (experienceType) =>
        experienceType.code != 'STU' &&
        experienceType.code != 'EXPDEXTER' &&
        experienceType.experiences.length > 0 &&
        someActiveExperience(experienceType.experiences)
    )
  })

  onMounted(async () => {
    try {
      await store.dispatch('getExperienceTypes')
      const scrollToClass = router.currentRoute.value.query.scrollToClass
      if (scrollToClass) {
        scrollToClassName(scrollToClass)
      }
    } catch (error) {
      registerError(error, 'getExperienceTypes')
    } finally {
      isLoading.value = false
    }
  })

  const goTo = async (experienceType) => {
    store.commit('setExperienceType', experienceType)

    if (experienceType.code === 'CINE') {
      router.push({ name: 'Cinema' })
    } else {
      router.push({
        name: 'ExperiencesByType',
        params: {
          experienceTypeCode: experienceType.code
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';

  .cards-experiences {
    @include d-flex(column, space-between, initial, 20px);
    padding: 20px;

    @media screen and (min-width: $sm-breakpoint) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
      padding: 20px 50px;
    }

    @media screen and (min-width: $md-breakpoint) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 50px;
      padding: 15px 50px 50px 50px;
    }

    @media screen and (min-width: $lg-breakpoint) and (orientation: landscape) {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 50px;
      padding: 15px 50px 50px 50px;
    }
  }

  .background-experiences {
    background: #f6f6f6;
    @media screen and (min-width: $sm-breakpoint) {
      background: var(--background-color);
    }
  }
</style>
